import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Image from 'app/components/layouts/Image';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import env from '.env.json';
import './styles.css';

const SectionAbout = () => {
  const { t } = useTranslation();
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e: Event) => {
      setDeferredPrompt(e);
    });
  }, [])

  const pushDetailButton = (path: string) => {
    return (
      <Link href={path}>
        <button type="button" className="btn btn-info my-2 px-5">
          {t('home.detail')}
        </button>
      </Link>
    )
  }

  const handleDownloadWeb = async () => {
    if (deferredPrompt !== null) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null)
      }
    }
  }

  return (
    <section id="about" className="about">
      <div className="justify-content-center">
        <div className="pt-2">
          <div className="section-tittle text-center">
            <b>
              <h1 className='mb-0'> {t('home.welcome')} <span>{env.APP_NAME}</span></h1>
              <p className='text-left mt-3'>
                {t('home.introduce', { name: env.APP_NAME })}
              </p>
              <p className='text-left mt-3'>
                {t('home.target', { name: env.APP_NAME })}
              </p>
              {deferredPrompt?.isTrusted &&
                <button className="btn btn-info" onClick={() => handleDownloadWeb()}>
                  <FontAwesomeIcon icon={faDownload} />
                  <b className='pl-1 mt-1'>{t('home.download')}</b>
                </button>
              }
            </b>
          </div>
        </div>
      </div>
      <div className="row mt-4 text-center pt-10 info-card">
        <div className="col-md-12 about-caption row">
          <div className="single-features mb-10 col-md-6">
            <div className="features-caption">
              <Image width={100} src="/images/commons/vocabulary.webp" alt={t('home.about_vocabulary')} />
              <h2 className="color-font mt-3">{t('home.about_vocabulary')}</h2>
              <p>{t('home.info_vocabulary')}</p>
              {pushDetailButton('/vocabularies/all')}
            </div>
          </div>
          <div className="single-features mb-10 col-md-6">
            <div className="features-caption">
              <Image width={100} src="/images/commons/grammar.webp" alt={t('home.about_grammar')} />
              <h2 className="color-font mt-3">{t('home.about_grammar')}</h2>
              <p>{t('home.info_grammar')}</p>
              {pushDetailButton('/grammar')}
            </div>
          </div>
          <div className="single-features mb-10 col-md-6">
            <div className="features-caption">
              <Image width={100} src="/images/commons/games.webp" alt={t('home.about_game')} />
              <h2 className="color-font mt-3">{t('home.about_game')}</h2>
              <p>{t('home.info_game')}</p>
              {pushDetailButton('/games')}
            </div>
          </div>
          <div className="single-features col-md-6">
            <div className="features-caption">
              <Image width={100} src="/images/commons/exam.webp" alt={t('home.about_test')} />
              <h2 className="color-font mt-3">{t('home.about_test')}</h2>
              <p>{t('home.info_test')}</p>
              {pushDetailButton('/tests/luyen-thi-trung-hoc-pho-thong-quoc-gia-mon-tieng-anh')}
            </div>
          </div>
          <div className="single-features mb-10 col-md-6">
            <div className="features-caption">
              <Image width={100} src="/images/commons/listening.webp" alt={t('home.about_listen')} />
              <h2 className="color-font mt-3">{t('home.about_listen')}</h2>
              <p>{t('home.info_listen')}</p>
              {pushDetailButton('/listening')}
            </div>
          </div>
          <div className="single-features col-md-6">
            <div className="features-caption">
              <Image width={100} src="/images/commons/music.webp" alt={t('home.about_music')} />
              <h2 className="color-font mt-3">{t('home.about_music')}</h2>
              <p>{t('home.info_music')}</p>
              {pushDetailButton('/music')}
            </div>
          </div>
        </div>
      </div>
      <hr />
    </section>
  )
}

export default SectionAbout
